// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__dWBQH","loaderInner":"Loader_loaderInner__to9ZV"};